/**
 * Resolves once the page has stopped changing for `quietMs` (only `targetQuietMs`
 * once a tooltip target is on the page), or after `maxMs`.
 * Intercom matches tooltips only once, against the DOM present when its boot
 * ping returns, so booting before page data renders loses that page load's
 * tooltips (later `update` calls do not bring them back).
 */
export function waitForDomSettled({ quietMs = 600, targetQuietMs = 200, maxMs = 4000, signal } = {}) {
  return new Promise((resolve) => {
    let quietTimer;
    let observer;
    const done = () => {
      clearTimeout(quietTimer);
      clearTimeout(maxTimer);
      observer?.disconnect();
      signal?.removeEventListener("abort", done);
      resolve();
    };
    const restart = () => {
      clearTimeout(quietTimer);
      const hasTarget = document.querySelector("[data-intercom-target]");
      quietTimer = setTimeout(done, hasTarget ? targetQuietMs : quietMs);
    };
    const maxTimer = setTimeout(done, maxMs);
    if (signal?.aborted) { done(); return; }
    signal?.addEventListener("abort", done);
    if (typeof MutationObserver === "function" && document.body) {
      observer = new MutationObserver(restart);
      observer.observe(document.body, { childList: true, subtree: true });
    }
    restart();
  });
}
